<template>
  <div class="w-full md:w-1/2">
    <div class="leading-loose max-w-xl m-4 p-7 bg-secondary-light dark:bg-secondary-dark rounded-xl shadow-xl text-left">
      <p class="font-general-medium text-primary-dark dark:text-primary-light text-2xl mb-8">
        {{ $t('contactFormTitle') }}
      </p>
      <form action="#" class="font-general-regular" @submit.prevent="sendForm" ref="form">

          <!-- 名前 -->
        <label class="block mb-2 mt-2 text-lg text-primary-dark dark:text-primary-light">
          {{ $t('nameTitle') }}
        </label>
        <input  type="text" name="user_name" v-model="form.user_name" class="input-style" @input="clearError('user_name')" />
        <p v-if="errors.user_name" class="text-red-500 text-sm">{{ errors.user_name }}</p>

        <!-- メール -->
        <label class="block mb-2 mt-4 text-lg text-primary-dark dark:text-primary-light">
          {{ $t('emailTitle') }}
        </label>
        <input type="email" name="user_email" v-model="form.user_email" class="input-style" @input="clearError('user_email')" />
        <p v-if="errors.user_email" class="text-red-500 text-sm">{{ errors.user_email }}</p>

        <!-- 件名 -->
        <label class="block mb-2 mt-4 text-lg text-primary-dark dark:text-primary-light">
          {{ $t('subjectTitle') }}
        </label>
        <input type="text" name="subject" v-model="form.subject" class="input-style" @input="clearError('subject')" />
        <p v-if="errors.subject" class="text-red-500 text-sm">{{ errors.subject }}</p>

        <!-- メッセージ -->
        <label class="block mb-2 mt-4 text-lg text-primary-dark dark:text-primary-light">
          {{ $t('messageTitle') }}
        </label>
        <textarea name="message" v-model="form.message" class="w-full px-5 py-2 border border-gray-300 dark:border-primary-dark border-opacity-50 text-primary-dark dark:text-secondary-light bg-ternary-light dark:bg-ternary-dark rounded-md shadow-sm text-md" @input="clearError('message')"></textarea>
        <p v-if="errors.message" class="text-red-500 text-sm">{{ errors.message }}</p>
        <div class="flex justify-center mt-4">
          <Button :title="$t('sendMessage')"
            class="px-4 py-2.5 text-white tracking-wider bg-cyan-500 hover:bg-cyan-600 focus:ring-1 focus:ring-cyan-900 rounded-lg duration-500"
            type="submit" aria-label="Send Message" value="Send"></Button>
        </div>
      </form>

      <div v-if="message" class="mt-4 text-center">
        <p class="text-lg text-green-500 dark:text-green-400">
          {{ message }}
        </p>
      </div>

      <div v-if="error" class="mt-4 text-center">
        <p class="text-lg text-red-500 dark:text-red-400">
          {{ error }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../reusable/Button.vue';
import emailjs from '@emailjs/browser';
export default {
  components: { Button, },
  data() {
    return {
      form: {
        user_name: '',
        user_email: '',
        subject: '',
        message: ''
      },
      errors: {},
      message: '',
      error: ''
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.errors = {};
      }
    }
  },
  methods: {
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = '';
      }
    },
    validateForm() {
      this.errors = {};
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isValid = true;

      if (!this.form.user_name) {
        this.errors.user_name = this.$t('formErrorName');
        isValid = false;
      }

      if (!this.form.user_email) {
        this.errors.user_email = this.$t('formErrorEmail');
        isValid = false;
      } else if (!emailPattern.test(this.form.user_email)) {
        this.errors.user_email = this.$t('formErrorEmailFormat');
        isValid = false;
      }

      if (!this.form.subject) {
        this.errors.subject = this.$t('formErrorSubject');
        isValid = false;
      }

      if (!this.form.message) {
        this.errors.message = this.$t('formErrorMessage');
        isValid = false;
      }

      return isValid;
    },
    sendForm() {
      if (!this.validateForm()) return;

      emailjs.send('service_slcya6s', 'template_q8rjcrb', this.form, 'NItmDZWVSXkbaV-Fs')
        .then(() => {
          this.message = this.$t('formSubmitSuccess');
          this.error = '';
          this.form = { user_name: '', user_email: '', subject: '', message: '' };
        })
        .catch(() => {
          this.error = this.$t('formSubmitError');
          this.message = '';
        });
    }
  },
};
</script>

<style scoped>
.input-style {
  @apply w-full px-5 py-3 border border-gray-300 dark:border-primary-dark rounded-md bg-ternary-light dark:bg-ternary-dark text-primary-dark dark:text-secondary-light;
}
</style>